import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useSubscription } from "@/hooks/useSubscription";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles } from "lucide-react";
import { TIER_RANK } from "@/lib/paddle";

export function PaywallGate({
  required = "starter_plan",
  feature,
  children,
}: {
  required?: keyof typeof TIER_RANK;
  feature: string;
  children: ReactNode;
}) {
  const { loading, hasTier, tier } = useSubscription();
  if (loading) return null;
  if (hasTier(required)) return <>{children}</>;

  const planLabel = required.replace("_plan", "").replace(/^./, (c) => c.toUpperCase());
  return (
    <div className="p-6">
      <Card className="max-w-xl mx-auto mt-12 border-dashed">
        <CardContent className="py-12 text-center space-y-4">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <h2 className="text-2xl font-semibold">{feature} is a {planLabel} feature</h2>
          <p className="text-muted-foreground">
            {tier
              ? `Your current plan doesn't include this. Upgrade to ${planLabel} or higher to unlock.`
              : `Subscribe to ${planLabel} or higher to unlock ${feature.toLowerCase()}.`}
          </p>
          <Button asChild size="lg" className="gap-2">
            <Link to="/pricing">
              <Sparkles className="h-4 w-4" /> View plans
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
